import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
    pageId: '',
    pageCategory: [],
    myCollectionCategory: []
  },
  mutations: {
    setCollectionPage (state, pageId) {
      state.pageId = pageId || ''
    },
    setPageCategory (state, data) {
      state.pageCategory = data || []
    },
    setMyCollectionCategory (state, data) {
      state.myCollectionCategory = data || []
    }
  },
  actions: {
    // 콜렉션페이지 생성
    async initCollectionPage ({ state, commit }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'collection-service-api',
          id: store.state.authentication.requestId,
          requestApi: 'init-collection-service-page',
          body: {
            pageName: data.pageName,
            catCode: data.catCode
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 모든 콜렉션페이지 리스트 호출
    async getCollectionPageList ({ state, commit }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'get-order-page-list',
          category: 'system-collection-service',
          id: store.state.authentication.requestId
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 콜렉션페이지 호출
    async getCollectionPage ({ state, commit }, pageId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'get-order-page',
          id: store.state.authentication.requestId,
          pageId: pageId
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 콜렉션페이지 업데이트
    async updateCollectionPage ({ state, commit }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'update-order-page',
          id: store.state.authentication.requestId,
          pageId: data.pageId,
          catCode: 'system_collection_service',
          pageName: data.pageName,
          settings: data.settings
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 콜렉션페이지 삭제
    async deleteCollectionPage ({ state, commit }, pageId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'delete-order-page',
          id: store.state.authentication.requestId,
          pageId: pageId
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 카테고리별 설정 저장(update)
    async putCollectionCategorySetting ({ state, commit }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'collection-service-api',
          requestApi: 'put-collection-category-setting',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            categoryId: data.categoryId,
            categorySetting: data.categorySetting
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 카테고리별 설정 호출
    async getCollectionCategorySetting ({ state, commit }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'collection-service-api',
          requestApi: 'get-collection-category-setting',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            categoryId: data.categoryId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 카테고리별 콜렉션아이템 리스트 호출
    async getCollectionItemList ({ state, commit }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'collection-service-api',
          requestApi: 'get-collection-items',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            categoryId: data.categoryId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 카테고리별 콜렉션아이템 순서 저장
    async setCollectionItemIndex ({ state, commit }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'collection-service-api',
          requestApi: 'set-collection-item-index',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            categoryId: data.categoryId,
            collectionItemIndex: data.collectionItemIndex
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 콜렉션아이템 생성
    async createCollectionItem ({ state, commit }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'collection-service-api',
          requestApi: 'create-collection-item',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            isActive: data.isActive,
            collectionItemId: data.collectionItemId,
            collectionItemName: data.collectionItemName,
            category: data.category,
            collectionCategory: data.collectionCategory,
            attribute: data.attribute,
            type: data.type || 'item',
            typeSetting: data.typeSetting || {},
            price: data.price
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 콜렉션아이템 호출
    async getCollectionItem ({ state, commit }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'collection-service-api',
          requestApi: 'get-collection-item',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            collectionItemId: data.collectionItemId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 콜렉션아이템 업데이트
    async updateCollectionItem ({ state, commit }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'collection-service-api',
          requestApi: 'update-collection-item',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            isActive: data.isActive,
            collectionItemId: data.collectionItemId,
            collectionItemName: data.collectionItemName,
            category: data.category,
            collectionCategory: data.collectionCategory,
            attribute: data.attribute,
            type: data.type || 'item',
            typeSetting: data.typeSetting || {},
            price: data.price
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 콜렉션아이템 삭제
    async deleteCollectionItem ({ state, commit }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'collection-service-api',
          requestApi: 'delete-collection-item',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            collectionItemId: data.collectionItemId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },

    // 카테고리별 콜렉션아이템 리스트 호출
    async getCollectionSubItemList ({ state, commit }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'collection-service-api',
          requestApi: 'get-collection-sub-items',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            categoryId: data.categoryId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 콜렉션 서브아이템 생성
    async createCollectionSubItem ({ state, commit }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'collection-service-api',
          requestApi: 'create-collection-sub-item',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            isActive: data.isActive,
            subItemId: data.collectionItemId,
            collectionItemName: data.collectionItemName,
            category: data.category,
            collectionCategory: data.collectionCategory,
            attribute: data.attribute,
            price: data.price
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 콜렉션 서브아이템 호출
    async getCollectionSubItem ({ state, commit }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'collection-service-api',
          requestApi: 'get-collection-sub-item',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            subItemId: data.collectionItemId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 콜렉션 서브아이템 업데이트
    async updateCollectionSubItem ({ state, commit }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'collection-service-api',
          requestApi: 'update-collection-sub-item',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            isActive: data.isActive,
            subItemId: data.collectionItemId,
            collectionItemName: data.collectionItemName,
            category: data.category,
            collectionCategory: data.collectionCategory,
            attribute: data.attribute,
            price: data.price
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 콜렉션 서브아이템 삭제
    async deleteCollectionSubItem ({ state, commit }, data) {
      console.log(data)
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'collection-service-api',
          requestApi: 'delete-collection-sub-item',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            subItemId: data.collectionItemId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },

    // 콜렉션페이지 카테고리 저장(create or update)
    async putCollectionCategory ({ state, commit }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'collection-service-api',
          id: store.state.authentication.requestId,
          requestApi: 'put-collection-category',
          body: {
            pageId: data.pageId,
            categories: data.categories
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 콜렉션페이지 카테고리 호출
    async getCollectionCategory ({ state, commit }, pageId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'collection-service-api',
          id: store.state.authentication.requestId,
          requestApi: 'get-collection-category',
          body: {
            pageId: pageId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 콜렉션페이지 네비게이션 저장(create or update)
    async putCollectionNav ({ state, commit }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'collection-service-api',
          id: store.state.authentication.requestId,
          requestApi: 'put-collection-navi',
          body: {
            pageId: data.pageId,
            naviSetting: data.naviSetting
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 콜렉션페이지 카테고리 호출
    async getCollectionNav ({ state, commit }, pageId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'collection-service-api',
          id: store.state.authentication.requestId,
          requestApi: 'get-collection-navi',
          body: {
            pageId: pageId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 마이콜렉션 저장(create or update)
    async putMyCollection ({ state, commit }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'collection-service-api',
          id: store.state.authentication.requestId,
          requestApi: 'put-collection-mycollection',
          body: {
            pageId: data.pageId,
            myCollectionSetting: data.myCollectionSetting
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 마이콜렉션 호출
    async getMyCollection ({ state, commit }, pageId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'collection-service-api',
          id: store.state.authentication.requestId,
          requestApi: 'get-collection-mycollection',
          body: {
            pageId: pageId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
  },
  getters: {
    getPageCategory: state => state.pageCategory,
    getMyCollectionCategory: state => state.myCollectionCategory,
    getCollectionResultData: () => (code) => {
      let result = true
      switch (code) {
        case 301:
          result = 'invalid_category' // 유효하지 카테고리로 설정할 수 없음
          break
        case 303:
          result = 'is_base_pos' // 포스연동 상품이라 특수 정보를 변경할 수 없음
          break
        case 304:
          result = 'include_preset' // 프리셋에 포함된 옵션임
          break
        case 305:
          result = 'exist_pId' // pId 중복
          break
        // 351~500까지는 공통에러
        case 351:
          result = 'invalid_format' // 형식에 맞지 않는 정보(invalid format)
          break
        case 401:
          result = 'inactivate' // 비활성화 또는 서비스 하지 않는 사이트
          break
        case 403:
          result = 'invalid_request' // 유효하지 않은 요청 데이터
          break
        case 405:
          result = 'invalid_site' // 사이트 정보가 없음
          break
        case 406:
          result = 'not_found_data' // 데이터가 없음
          break
        case 500:
          result = 'system_error' // 내부 오류
          break
      }
      return result
    },
    getCategoryNameById: state => categoryId => {
      function findCategoryLabelById (data, categoryId) {
        for (const item of data) {
          if (item.categoryId === categoryId) {
            return item.categoryLabel
          }
          if (item.subCategory) {
            const found = findCategoryLabelById(item.subCategory, categoryId)
            if (found) return found
          }
        }
        return null // 없으면 null 반환
      }
      return findCategoryLabelById(state.pageCategory, categoryId)
    },
    getCategorById: state => categoryId => {
      function findCategoryById (data, categoryId) {
        for (const item of data) {
          if (item.categoryId === categoryId) {
            return item
          }
          if (item.subCategory) {
            const found = findCategoryLabelById(item.subCategory, categoryId)
            if (found) return found
          }
        }
        return null // 없으면 null 반환
      }
      return findCategoryById(state.pageCategory, categoryId)
    }
  }
}
